<template>
  <b-card
    class="profile-header mb-2"
    :img-src="require('@/assets/images/header/bf.jpg')"
    img-top
    alt="cover photo"
    body-class="p-0"
  />
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
  },
}
</script>
<style>
.titulocolor{
  background-color: #ffffffbf;
}
.titulocolor h3, .titulocolor p{
  color: #008835;
}
.titulocolor hr {
  border-color: #008835;
}
.titulocolor{
  border-top-left-radius: 5px;
}
@media (max-width: 650px) {
  .titulocolor {
    display: none !important;
  }
}
</style>
